import {Platform} from 'react-native';

// UI troubles described in this task https://app.asana.com/0/1201899936974223/1202462624877699/f
const emailsWithEditRecordsUITroubles = new Set(['v.kuznetsov@proscom.ru', 'v.ilyin@proscom.ru']);

export function hasEditRecordsUITroubles(email: string) {
  return Platform.OS === 'ios' && emailsWithEditRecordsUITroubles.has(email);
}
